/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Material UI
import { MaterialReactTable } from "material-react-table";
import {Chip} from "@mui/material";

// Gateway y URLs
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

// Componentes
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import BillableActivityListHeader from "../BillableActivityListHeader/BillableActivityListHeader";
import BillableActivityFilter from "../BillableActivityListHeader/Filter/BillableActivityFilter";
import AddBillingActivities from "../AddBillingActivity/AddBillingActivities";
import BillableActivityDetail from "../Modal/BillableActivityDetail";


// Helpers
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import { 
  getAllBillableActivities,
  getAllPotentialActivities,
  createFromPotentialActivity
} from "helper/BillingHelper/BillingHelper";

const BillableActivitiesListBody = () => {
  // ============================================================
  // 1. HOOKS
  // ============================================================
  const { t, i18n } = useTranslation();

  // ============================================================
  // 2. AUTENTICACIÓN
  // ============================================================
  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // ============================================================
  // 3. ESTADOS PRINCIPALES
  // ============================================================
  const [isLoading, setIsLoading] = useState(false);
  const [activitiesList, setActivitiesList] = useState([]);
  const [filteredActivitiesList, setFilteredActivitiesList] = useState([]);
  const [currentTab, setCurrentTab] = useState(0); // 0 = Potenciales, 1 = Facturadas
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailDrawer, setShowDetailDrawer] = useState(false);
const [selectedActivityForDetail, setSelectedActivityForDetail] = useState(null);

  // Estados de selección
  const [rowSelection, setRowSelection] = useState({});
  const [selectedActivityIds, setSelectedActivityIds] = useState([]);
  const [patientsData, setPatientsData] = useState([]);
  // Alertas
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Estados de filtros
  const [activeFilters, setActiveFilters] = useState([]);

  // Estados de eliminación
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [isDeleting, setIsDeleting] = useState(false);
const [deleteMode, setDeleteMode] = useState('soft'); // 'soft' o 'hard'

  // ============================================================
  // 4. FUNCIONES DE API
  // ============================================================

const fetchAvailablePatients = async () => {
  try {
    console.log('🔍 Cargando pacientes disponibles...');
    
    // Construir URL completa manualmente
    const fullUrl = `${url.API_BASE_URL}${url.API_GET_APP_USERS}?token=${token}`;
    console.log('📡 URL completa:', fullUrl);
    
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error('Error al cargar pacientes');
    }

    const result = await response.json();
    
    if (!result || !result.data) {
      console.warn('⚠️ No se recibieron datos de pacientes');
      setPatientsData([]);
      return [];
    }
    
    const allPatients = result.data.filter(user => 
      user.userrole === 'Patient' || 
      user.role?.slug === 'PATIENT' || 
      user.role?.name === 'Patient'
    ) || [];
    
    const formattedPatients = allPatients.map(patient => ({
      _id: patient._id,
      customid: patient.customid,
      name: patient.name,
      surname: patient.surname,
      fullName: `${patient.name} ${patient.surname || ''}`.trim(),
      email: patient.email || null,
      phone: patient.phone || null,
      address: patient.address || null,
      city: patient.city || null,
      state: patient.state || null,
      zipcode: patient.zipcode || null,
      type: 'Account',
      display_name: `${patient.name} ${patient.surname || ''}`.trim(),
      type_description: 'Paciente'
    }));
    
    console.log('✅ Pacientes cargados:', formattedPatients.length);
    setPatientsData(formattedPatients);
    return formattedPatients;
    
  } catch (error) {
    console.error('❌ Error cargando pacientes:', error);
    setPatientsData([]);
    return [];
  }
};

const enrichActivitiesWithPatientData = (activities, patients) => {
  console.log('🔄 Iniciando enriquecimiento de actividades...');
  console.log('📊 Total actividades:', activities.length);
  console.log('👥 Total pacientes:', patients.length);
  
  const patientMap = new Map();
  patients.forEach(patient => {
    if (patient._id) {
      patientMap.set(patient._id, patient);
    }
  });
  
  console.log('🗺️ PatientMap creado con', patientMap.size, 'entradas');
  
  let matchCount = 0;
  let noMatchCount = 0;
  let enrichedCount = 0; // Contador de nombres asignados
  
  const enriched = activities.map((activity, index) => {
    const activityPatientId = activity.patient_id?.trim?.() || null;
    
    // Si es null o vacío, no hay patient_id
    if (!activityPatientId || activityPatientId === 'null') {
      noMatchCount++;
      if (index < 5) {
        console.log(`❌ Actividad ${index + 1}: patient_id es null o vacío`);
      }
      return {
        ...activity,
        patient_name: activity.patient_name || 'Sin paciente asignado',
        patient_complete: null
      };
    }
    
    // Buscar en el Map
    const patient = patientMap.get(activityPatientId);
    
    if (patient) {
      matchCount++;
      
      // ✅ ENRIQUECER: Si tiene ID pero no tiene nombre, asignar el nombre del paciente
      const hasValidName = activity.patient_name && 
                          activity.patient_name.trim() !== '' &&
                          activity.patient_name !== 'Sin paciente asignado' &&
                          activity.patient_name !== 'Paciente no encontrado';
      
      if (!hasValidName) {
        enrichedCount++;
        if (index < 5) {
          console.log(`✨ Actividad ${index + 1}: Nombre asignado - "${patient.fullName}"`);
        }
      } else if (index < 5) {
        console.log(`✅ Actividad ${index + 1}: Match encontrado - ya tiene nombre`);
      }
      
      return {
        ...activity,
        patient_name: patient.fullName, // ✅ SIEMPRE asignar el nombre del Map
        patient_complete: {
          _id: patient._id,
          customid: patient.customid,
          name: patient.name,
          surname: patient.surname,
          fullName: patient.fullName,
          email: patient.email,
          phone: patient.phone,
          address: patient.address,
          city: patient.city,
          state: patient.state,
          zipcode: patient.zipcode
        }
      };
    } else {
      noMatchCount++;
      if (index < 5) {
        console.log(`❌ Actividad ${index + 1}: No match encontrado para patient_id: "${activityPatientId}"`);
      }
      
      return {
        ...activity,
        patient_name: activity.patient_name || 'Paciente no encontrado',
        patient_complete: null
      };
    }
  });
  
  console.log('\n📈 RESUMEN DEL ENRIQUECIMIENTO:');
  console.log(`   ✅ Matches exitosos: ${matchCount}`);
  console.log(`   ✨ Nombres asignados/actualizados: ${enrichedCount}`);
  console.log(`   ❌ Sin match: ${noMatchCount}`);
  console.log(`   📊 Total procesadas: ${activities.length}`);
  
  return enriched;
};

/**
 * Obtiene actividades potenciales (no facturadas aún)
 */
const fetchPotentialActivities = async () => {
  setRowSelection({});
  setSelectedActivityIds([]);

  try {
    setIsLoading(true);

    // 1. Primero cargar pacientes
    const patients = await fetchAvailablePatients();

    // 2. Luego cargar actividades
    const response = await getAllPotentialActivities();

    if (response && response.success) {
      // Combinar todas las actividades en un array plano
      const allActivities = [
        ...(response.data.appointments || []),
        ...(response.data.medical_tests || []),
        ...(response.data.diagnostic_imaging || []),
        ...(response.data.immunizations || []),
        ...(response.data.medicines || []),
        ...(response.data.prescriptions || []),
        ...(response.data.treatments || []),
      ];

      // Filtrar solo las no facturadas
      const unbilledActivities = allActivities.filter(activity => !activity.is_billed);

      // 3. Enriquecer con datos de pacientes SOLO EN POTENCIALES
      const enrichedActivities = enrichActivitiesWithPatientData(unbilledActivities, patients);

      // ✅ FILTRAR actividades sin paciente asignado
      const activitiesWithPatient = enrichedActivities.filter(activity => {
        const hasValidPatientId = activity.patient_id && 
                                  activity.patient_id !== 'null' && 
                                  activity.patient_id.trim() !== '';
        const hasValidPatientName = activity.patient_name && 
                                    activity.patient_name.trim() !== '' &&
                                    activity.patient_name !== 'Sin paciente asignado' &&
                                    activity.patient_name !== 'Paciente no encontrado';
        
        return hasValidPatientId || hasValidPatientName;
      });

      console.log('✅ Actividades potenciales con paciente válido:', activitiesWithPatient.length);
      console.log('❌ Actividades filtradas (sin paciente):', enrichedActivities.length - activitiesWithPatient.length);

      setMessageType("success");
      setAlertMessage(t("Potential Activities fetched successfully"));
      setActivitiesList(activitiesWithPatient);
      setFilteredActivitiesList(activitiesWithPatient);
    } else {
      setMessageType("error");
      setAlertMessage(response?.message || t("Error loading activities"));
    }
  } catch (error) {
    setAlertMessage(error.message);
    setMessageType("error");
  } finally {
    setShowAlert(true);
    setIsLoading(false);
  }
};

/**
 * Obtiene actividades ya facturadas
 */
const fetchBilledActivities = async () => {
  setRowSelection({});
  setSelectedActivityIds([]);

  try {
    setIsLoading(true);

    // NO cargar pacientes ni enriquecer en billed activities
    const response = await getAllBillableActivities();

    if (response && response.success) {
      const activities = Array.isArray(response.data) ? response.data : [];

      // ✅ FILTRAR actividades sin paciente asignado
      const activitiesWithPatient = activities.filter(activity => {
        const hasValidPatientId = activity.patient_id && 
                                  activity.patient_id !== 'null' && 
                                  activity.patient_id.trim() !== '';
        const hasValidPatientName = activity.patient_name && 
                                    activity.patient_name.trim() !== '';
        
        return hasValidPatientId || hasValidPatientName;
      });

      console.log('✅ Actividades facturadas con paciente válido:', activitiesWithPatient.length);
      console.log('❌ Actividades filtradas (sin paciente):', activities.length - activitiesWithPatient.length);

      setMessageType("success");
      setAlertMessage(t("Billed Activities fetched successfully"));
      setActivitiesList(activitiesWithPatient);
      setFilteredActivitiesList(activitiesWithPatient);
    } else {
      setMessageType("error");
      setAlertMessage(response?.message || t("Error loading activities"));
      setActivitiesList([]);
      setFilteredActivitiesList([]);
    }
  } catch (error) {
    setAlertMessage(error.message);
    setMessageType("error");
    setActivitiesList([]);
    setFilteredActivitiesList([]);
  } finally {
    setShowAlert(true);
    setIsLoading(false);
  }
};

/**
 * Elimina múltiples actividades seleccionadas (soft o hard delete)
 */
const handleBulkDelete = async () => {
  if (selectedActivityIds.length === 0) {
    setMessageType("warning");
    setAlertMessage(t("No activities selected"));
    setShowAlert(true);
    return;
  }

  try {
    setIsDeleting(true);
    
    console.log(`🗑️ ${deleteMode === 'hard' ? 'HARD' : 'SOFT'} DELETE:`, selectedActivityIds);

    // Determinar endpoint según el modo
    const endpoint = deleteMode === 'hard' 
      ? '/billing/activities/bulk-hard-delete'
      : '/billing/activities/bulk-soft-delete';

    const response = await fetch(
      `${url.API_BASE_URL}${endpoint}?token=${token}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          activity_ids: selectedActivityIds,
          reason: deleteMode === 'hard' 
            ? 'Hard deletion to allow re-billing' 
            : 'Soft deletion from UI'
        })
      }
    );

    const result = await response.json();

    if (result.success) {
      const deletedCount = result.data?.deleted_successfully || selectedActivityIds.length;
      
      setMessageType("success");
      setAlertMessage(
        deleteMode === 'hard'
          ? t(`Successfully permanently deleted ${deletedCount} activities`)
          : t(`Successfully soft deleted ${deletedCount} activities`)
      );
      
      // Mostrar errores si los hay
      if (result.data?.errors?.length > 0) {
        console.warn('⚠️ Some deletions failed:', result.data.errors);
      }
      
      // Limpiar selección y recargar
      setRowSelection({});
      setSelectedActivityIds([]);
      setShowDeleteModal(false);
      setDeleteMode('soft'); // Reset to default
      reloadList();
    } else {
      setMessageType("error");
      setAlertMessage(result.message || t("Error deleting activities"));
    }
  } catch (error) {
    console.error('❌ Error en bulk delete:', error);
    setMessageType("error");
    setAlertMessage(t("Error deleting activities: ") + error.message);
  } finally {
    setShowAlert(true);
    setIsDeleting(false);
  }
};

/**
 * Exporta las actividades seleccionadas a CSV
 */
const handleExportToCSV = () => {
  if (selectedActivityIds.length === 0) {
    setAlertMessage(t("Please select at least one activity to export"));
    setMessageType("warning");
    setShowAlert(true);
    return;
  }

  console.log('📊 Exportando a CSV:', selectedActivityIds);

  // Filtrar las actividades seleccionadas
  const selectedActivities = filteredActivitiesList.filter(activity =>
    selectedActivityIds.includes(currentTab === 0 ? activity.source_id : activity._id)
  );

  console.log('✅ Actividades encontradas para CSV:', selectedActivities.length);

  if (selectedActivities.length === 0) {
    setAlertMessage(t("No activities found to export"));
    setMessageType("error");
    setShowAlert(true);
    return;
  }

  // Crear encabezados CSV según el tab actual
  const headers = currentTab === 0 
    ? [
        "ID",
        "Tipo de Actividad",
        "Paciente",
        "Email Paciente",
        "Teléfono",
        "Doctor",
        "Descripción",
        "Fecha de Servicio",
        "Precio",
        "Estado Facturación"
      ]
    : [
        "ID",
        "Tipo de Actividad",
        "Paciente",
        "Descripción",
        "Precio Unitario",
        "Cantidad",
        "Total",
        "Estado",
        "Fecha de Servicio"
      ];
  
  // Crear filas CSV según el tab actual
  const rows = selectedActivities.map(activity => {
    if (currentTab === 0) {
      // Potential Activities
      return [
        activity.source_id || "",
        activity.activity_type || "",
        activity.patient_complete?.fullName || activity.patient_name || "",
        activity.patient_complete?.email || "",
        activity.patient_complete?.phone || "",
        activity.doctor_name || "",
        activity.description || "",
        activity.service_date ? new Date(activity.service_date).toLocaleDateString() : "",
        activity.product_price ? `€${Number(activity.product_price).toFixed(2)}` : "",
        activity.is_billed ? "Facturado" : "No Facturado"
      ];
    } else {
      // Billed Activities
      return [
        activity._id || "",
        activity.activity_type || "",
        activity.patient_name || "",
        activity.description || "",
        activity.unit_price ? `€${Number(activity.unit_price).toFixed(2)}` : "",
        activity.quantity || "",
        activity.total_amount ? `€${Number(activity.total_amount).toFixed(2)}` : "",
        activity.billing_status || "",
        activity.service_date ? new Date(activity.service_date).toLocaleDateString() : ""
      ];
    }
  });

  // Combinar encabezados y filas
  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","))
  ].join("\n");

  // Crear y descargar archivo
  const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  const tabName = currentTab === 0 ? "potenciales" : "facturadas";
  const fileName = `actividades_${tabName}_${new Date().toISOString().split('T')[0]}.csv`;
  
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Mostrar mensaje de éxito
  setAlertMessage(t(`Successfully exported ${selectedActivities.length} activities to CSV`));
  setMessageType("success");
  setShowAlert(true);
};

/**
 * Exporta las actividades seleccionadas a PDF
 */
const handleExportToPDF = () => {
  if (selectedActivityIds.length === 0) {
    setAlertMessage(t("Please select at least one activity to export"));
    setMessageType("warning");
    setShowAlert(true);
    return;
  }

  console.log('📄 Exportando a PDF:', selectedActivityIds);

  // Filtrar las actividades seleccionadas
  const selectedActivities = filteredActivitiesList.filter(activity =>
    selectedActivityIds.includes(currentTab === 0 ? activity.source_id : activity._id)
  );

  console.log('✅ Actividades encontradas para PDF:', selectedActivities.length);

  if (selectedActivities.length === 0) {
    setAlertMessage(t("No activities found to export"));
    setMessageType("error");
    setShowAlert(true);
    return;
  }

  // Calcular totales
  let totalAmount = 0;
  selectedActivities.forEach(activity => {
    const amount = currentTab === 0 
      ? Number(activity.product_price || 0)
      : Number(activity.total_amount || 0);
    totalAmount += amount;
  });

  // Crear contenido HTML para PDF
  const tabName = currentTab === 0 ? "Actividades Potenciales" : "Actividades Facturadas";
  
  const tableRows = selectedActivities.map(activity => {
    if (currentTab === 0) {
      // Potential Activities
      return `
        <tr>
          <td>${activity.source_id || 'N/A'}</td>
          <td><span class="badge">${activity.activity_type || 'N/A'}</span></td>
          <td>
            <strong>${activity.patient_complete?.fullName || activity.patient_name || 'N/A'}</strong><br>
            <small>${activity.patient_complete?.email || ''}</small><br>
            <small>${activity.patient_complete?.phone || ''}</small>
          </td>
          <td>${activity.doctor_name || 'N/A'}</td>
          <td>${activity.description || 'N/A'}</td>
          <td>${activity.service_date ? new Date(activity.service_date).toLocaleDateString('es-ES') : 'N/A'}</td>
          <td class="text-end"><strong>€${activity.product_price ? Number(activity.product_price).toFixed(2) : '0.00'}</strong></td>
          <td><span class="badge ${activity.is_billed ? 'badge-success' : 'badge-warning'}">${activity.is_billed ? 'Facturado' : 'No Facturado'}</span></td>
        </tr>
      `;
    } else {
      // Billed Activities
      return `
        <tr>
          <td>${activity._id?.substring(0, 8) || 'N/A'}</td>
          <td><span class="badge">${activity.activity_type || 'N/A'}</span></td>
          <td><strong>${activity.patient_name || 'N/A'}</strong></td>
          <td>${activity.description || 'N/A'}</td>
          <td class="text-end">€${activity.unit_price ? Number(activity.unit_price).toFixed(2) : '0.00'}</td>
          <td class="text-center">${activity.quantity || '1'}</td>
          <td class="text-end"><strong>€${activity.total_amount ? Number(activity.total_amount).toFixed(2) : '0.00'}</strong></td>
          <td><span class="badge badge-${activity.billing_status === 'PAID' ? 'success' : 'info'}">${activity.billing_status || 'N/A'}</span></td>
          <td>${activity.service_date ? new Date(activity.service_date).toLocaleDateString('es-ES') : 'N/A'}</td>
        </tr>
      `;
    }
  }).join('');

  const tableHeaders = currentTab === 0
    ? `
      <tr>
        <th>ID</th>
        <th>Tipo</th>
        <th>Paciente</th>
        <th>Doctor</th>
        <th>Descripción</th>
        <th>Fecha</th>
        <th>Precio</th>
        <th>Estado</th>
      </tr>
    `
    : `
      <tr>
        <th>ID</th>
        <th>Tipo</th>
        <th>Paciente</th>
        <th>Descripción</th>
        <th>P. Unitario</th>
        <th>Cant.</th>
        <th>Total</th>
        <th>Estado</th>
        <th>Fecha</th>
      </tr>
    `;

  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${tabName} - Exportación</title>
      <meta charset="utf-8">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body { 
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          padding: 30px;
          color: #333;
          background: #fff;
        }
        
        .header {
          border-bottom: 4px solid #3498db;
          padding-bottom: 20px;
          margin-bottom: 30px;
        }
        
        h1 { 
          color: #2c3e50;
          font-size: 28px;
          margin-bottom: 10px;
        }
        
        .info-box {
          background: #f8f9fa;
          border-left: 4px solid #3498db;
          padding: 15px 20px;
          margin: 20px 0;
          border-radius: 4px;
        }
        
        .info-box p {
          margin: 8px 0;
          font-size: 14px;
        }
        
        .info-box strong {
          color: #2c3e50;
          margin-right: 10px;
        }
        
        .summary-cards {
          display: flex;
          gap: 20px;
          margin: 25px 0;
        }
        
        .summary-card {
          flex: 1;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        
        .summary-card h3 {
          font-size: 14px;
          margin-bottom: 10px;
          opacity: 0.9;
        }
        
        .summary-card .value {
          font-size: 32px;
          font-weight: bold;
        }
        
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin-top: 25px;
          font-size: 11px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        th, td { 
          border: 1px solid #e0e0e0; 
          padding: 12px 10px; 
          text-align: left; 
        }
        
        th { 
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 10px;
          letter-spacing: 0.5px;
        }
        
        tr:nth-child(even) {
          background-color: #f8f9fa;
        }
        
        tr:hover {
          background-color: #e3f2fd;
        }
        
        .text-end {
          text-align: right;
        }
        
        .text-center {
          text-align: center;
        }
        
        .badge {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 10px;
          font-weight: 600;
          background: #e3f2fd;
          color: #1976d2;
        }
        
        .badge-success {
          background: #e8f5e9;
          color: #2e7d32;
        }
        
        .badge-warning {
          background: #fff3e0;
          color: #f57c00;
        }
        
        .badge-info {
          background: #e1f5fe;
          color: #0277bd;
        }
        
        .total-row {
          background: #f0f0f0;
          font-weight: bold;
          border-top: 2px solid #333;
        }
        
        .footer {
          margin-top: 40px;
          padding-top: 20px;
          border-top: 2px solid #e0e0e0;
          text-align: center;
          font-size: 11px;
          color: #999;
        }
        
        @media print {
          body { 
            padding: 20px;
          }
          .summary-cards {
            page-break-inside: avoid;
          }
          table {
            page-break-inside: auto;
          }
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>📊 ${tabName}</h1>
        <p style="color: #666; margin-top: 5px;">Reporte de Exportación</p>
      </div>
      
      <div class="info-box">
        <p><strong>📅 Fecha de exportación:</strong> ${new Date().toLocaleString('es-ES', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })}</p>
        <p><strong>👤 Usuario:</strong> ${userInfo?.name || 'N/A'} ${userInfo?.surname || ''}</p>
        <p><strong>🏥 Rol:</strong> ${userInfo?.role?.name || 'N/A'}</p>
      </div>
      
      <div class="summary-cards">
        <div class="summary-card">
          <h3>Total de Actividades</h3>
          <div class="value">${selectedActivities.length}</div>
        </div>
        <div class="summary-card" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
          <h3>Importe Total</h3>
          <div class="value">€${totalAmount.toFixed(2)}</div>
        </div>
      </div>
      
      <table>
        <thead>
          ${tableHeaders}
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="${currentTab === 0 ? '6' : '6'}" class="text-end">TOTAL:</td>
            <td class="text-end">€${totalAmount.toFixed(2)}</td>
            <td colspan="${currentTab === 0 ? '1' : '2'}"></td>
          </tr>
        </tfoot>
      </table>
      
      <div class="footer">
        <p>Este documento ha sido generado automáticamente por el sistema de gestión clínica</p>
        <p>© ${new Date().getFullYear()} - Documento confidencial</p>
      </div>
    </body>
    </html>
  `;
  
  // Crear ventana de impresión
  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  printWindow.focus();
  
  // Esperar a que cargue y luego imprimir
  setTimeout(() => {
    printWindow.print();
  }, 500);

  // Mostrar mensaje de éxito
  setAlertMessage(t(`Successfully exported ${selectedActivities.length} activities to PDF`));
  setMessageType("success");
  setShowAlert(true);
};

  /**
   * Función para recargar la lista según el tab actual
   */
  const reloadList = () => {
    if (currentTab === 0) {
      fetchPotentialActivities();
    } else {
      fetchBilledActivities();
    }
  };
  

  /**
 * Obtiene los objetos completos de las actividades seleccionadas
 */
const getSelectedActivities = () => {
  return filteredActivitiesList.filter(activity => 
    selectedActivityIds.includes(
      currentTab === 0 ? activity.source_id : activity._id
    )
  );
};

/**
 * Maneja el éxito al crear actividades
 */
const handleCreateSuccess = (message) => {
  setMessageType("success");
  setAlertMessage(message);
  setShowAlert(true);
  setRowSelection({});
  setSelectedActivityIds([]);
  reloadList();
};

  // ============================================================
  // 5. FUNCIONES DE FILTROS
  // ============================================================

  /**
   * Aplica los filtros a la lista de actividades
   */
  const handleApplyFilters = (filters) => {
    let filtered = [...activitiesList];
    const newActiveFilters = [];

    // Filtro por tipo de actividad
    if (filters.activityType) {
      filtered = filtered.filter(activity => 
        activity.activity_type === filters.activityType
      );
      newActiveFilters.push({
        key: 'activityType',
        label: `${t('Type')}: ${t(filters.activityType)}`,
        value: filters.activityType
      });
    }

    // Filtro por nombre de paciente
    if (filters.patientName) {
      filtered = filtered.filter(activity =>
        activity.patient_name?.toLowerCase().includes(filters.patientName.toLowerCase())
      );
      newActiveFilters.push({
        key: 'patientName',
        label: `${t('Patient')}: ${filters.patientName}`,
        value: filters.patientName
      });
    }

    // Filtro por nombre de doctor
    if (filters.doctorName) {
      filtered = filtered.filter(activity =>
        activity.doctor_name?.toLowerCase().includes(filters.doctorName.toLowerCase())
      );
      newActiveFilters.push({
        key: 'doctorName',
        label: `${t('Doctor')}: ${filters.doctorName}`,
        value: filters.doctorName
      });
    }

    // Filtro por estado de facturación (solo para actividades facturadas)
    if (currentTab === 1 && filters.billingStatus) {
      filtered = filtered.filter(activity =>
        activity.billing_status === filters.billingStatus
      );
      newActiveFilters.push({
        key: 'billingStatus',
        label: `${t('Status')}: ${t(filters.billingStatus)}`,
        value: filters.billingStatus
      });
    }

    // Filtro por estado is_billed (solo para actividades potenciales)
    if (currentTab === 0 && filters.isBilled !== "") {
      const isBilledBool = filters.isBilled === "true";
      filtered = filtered.filter(activity =>
        activity.is_billed === isBilledBool
      );
      newActiveFilters.push({
        key: 'isBilled',
        label: `${t('Status')}: ${isBilledBool ? t('Billed') : t('Unbilled')}`,
        value: filters.isBilled
      });
    }

    // Filtro por rango de fechas
    if (filters.dateFrom) {
      filtered = filtered.filter(activity => {
        const activityDate = new Date(activity.service_date);
        const fromDate = new Date(filters.dateFrom);
        return activityDate >= fromDate;
      });
      newActiveFilters.push({
        key: 'dateFrom',
        label: `${t('From')}: ${new Date(filters.dateFrom).toLocaleDateString()}`,
        value: filters.dateFrom
      });
    }

    if (filters.dateTo) {
      filtered = filtered.filter(activity => {
        const activityDate = new Date(activity.service_date);
        const toDate = new Date(filters.dateTo);
        return activityDate <= toDate;
      });
      newActiveFilters.push({
        key: 'dateTo',
        label: `${t('To')}: ${new Date(filters.dateTo).toLocaleDateString()}`,
        value: filters.dateTo
      });
    }

    // Filtro por rango de precio
    if (filters.minPrice) {
      filtered = filtered.filter(activity => {
        const price = currentTab === 0 
          ? Number(activity.product_price || 0)
          : Number(activity.unit_price || 0);
        return price >= Number(filters.minPrice);
      });
      newActiveFilters.push({
        key: 'minPrice',
        label: `${t('Min Price')}: €${filters.minPrice}`,
        value: filters.minPrice
      });
    }

    if (filters.maxPrice) {
      filtered = filtered.filter(activity => {
        const price = currentTab === 0 
          ? Number(activity.product_price || 0)
          : Number(activity.unit_price || 0);
        return price <= Number(filters.maxPrice);
      });
      newActiveFilters.push({
        key: 'maxPrice',
        label: `${t('Max Price')}: €${filters.maxPrice}`,
        value: filters.maxPrice
      });
    }

    setFilteredActivitiesList(filtered);
    setActiveFilters(newActiveFilters);
  };

  /**
   * Elimina un filtro específico
   */
  const handleRemoveFilter = (filterKey) => {
    const updatedFilters = activeFilters.filter(f => f.key !== filterKey);
    
    // Reconstruir objeto de filtros
    const filtersObj = {
      activityType: "",
      patientName: "",
      doctorName: "",
      billingStatus: "",
      dateFrom: "",
      dateTo: "",
      minPrice: "",
      maxPrice: "",
      isBilled: ""
    };

    updatedFilters.forEach(filter => {
      filtersObj[filter.key] = filter.value;
    });

    handleApplyFilters(filtersObj);
  };

  /**
   * Limpia todos los filtros
   */
  const handleClearAllFilters = () => {
    setActiveFilters([]);
    setFilteredActivitiesList(activitiesList);
  };

  // Función para abrir el detalle:
const handleViewDetail = (activity) => {
  console.log('🔍 Opening detail for activity:', activity);
  
  // Pasar la actividad completa en lugar de solo el ID
  setSelectedActivityForDetail(activity);
  setShowDetailDrawer(true);
};

// Función para abrir pivot
const handleOpenPivot = () => {
  setShowPivotTable(true);
};
  // ============================================================
  // 6. CONFIGURACIÓN DE TABLA PARA ACTIVIDADES POTENCIALES
  // ============================================================
  
  const potentialActivitiesColumns = useMemo(() => [
  {
    accessorKey: "activity_type",
    header: t("Tipo"),
    size: 150,
    Cell: ({ row }) => (
      <Chip 
        label={t(row.original.activity_type || "OTHER")}
        size="small"
        color="primary"
        variant="outlined"
      />
    ),
  },
  {
    accessorKey: "patient_name",
    header: t("Patient"),
    size: 250,
    Cell: ({ row }) => {
      const patient = row.original.patient_complete;
      return (
        <div>
          <div className="fw-semibold">
            {patient?.fullName || row.original.patient_name || "-"}
          </div>
          {patient?.email && (
            <div className="text-muted small">{patient.email}</div>
          )}
          {patient?.phone && (
            <div className="text-muted small">📞 {patient.phone}</div>
          )}
          {patient?.customid && (
            <div className="text-muted small">
              <span className="badge bg-light text-dark">ID: {patient.customid}</span>
            </div>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "doctor_name",
    header: t("Doctor"),
    size: 200,
  },
  {
    accessorKey: "description",
    header: t("Descripción"),
    size: 250,
  },
  {
    accessorKey: "service_date",
    header: t("Fecha"),
    size: 150,
    Cell: ({ row }) => 
      row.original.service_date 
        ? new Date(row.original.service_date).toLocaleDateString()
        : "-"
  },
  {
    accessorKey: "product_price",
    header: t("Precio"),
    size: 120,
    Cell: ({ row }) => 
      row.original.product_price 
        ? `€${Number(row.original.product_price).toFixed(2)}`
        : "-",
  },
  {
    accessorKey: "is_billed",
    header: t("Estado"),
    size: 130,
    Cell: ({ row }) => (
      <Chip 
        label={row.original.is_billed ? t("Billed") : t("Unbilled")}
        size="small"
        color={row.original.is_billed ? "success" : "warning"}
      />
    ),
  },
], [t]);

  // ============================================================
  // 7. CONFIGURACIÓN DE TABLA PARA ACTIVIDADES FACTURADAS
  // ============================================================

  const billedActivitiesColumns = useMemo(() => [  
  {
    accessorKey: "activity_type",
    header: t("Tipo"),
    size: 150,
    Cell: ({ row }) => (
      <Chip 
        label={t(row.original.activity_type)}
        size="small"
        color="primary"
        variant="outlined"
      />
    ),
  },
  {
    accessorKey: "patient_name",
    header: t("Patient"),
    size: 250,
    Cell: ({ row }) => {
      const patient = row.original.patient_complete;
      return (
        <div>
          <div className="fw-semibold">
            {patient?.fullName || row.original.patient_name || "-"}
          </div>
          {patient?.email && (
            <div className="text-muted small">{patient.email}</div>
          )}
          {patient?.phone && (
            <div className="text-muted small">📞 {patient.phone}</div>
          )}
          {patient?.address && (
            <div className="text-muted small">
              📍 {patient.address}
              {patient.city && `, ${patient.city}`}
              {patient.zipcode && ` ${patient.zipcode}`}
            </div>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "description",
    header: t("Description"),
    size: 250,
  },
  {
    accessorKey: "unit_price",
    header: t("Unit Price"),
    size: 120,
    Cell: ({ row }) => `€${row.original.unit_price?.toFixed(2) || "0.00"}`,
  },
  {
    accessorKey: "quantity",
    header: t("Quantity"),
    size: 100,
  },
  {
    accessorKey: "total_amount",
    header: t("Total"),
    size: 120,
    Cell: ({ row }) => (
      <span className="fw-semibold">
        €{row.original.total_amount?.toFixed(2) || "0.00"}
      </span>
    ),
  },
  {
    accessorKey: "billing_status",
    header: t("Status"),
    size: 130,
    Cell: ({ row }) => {
      const statusColors = {
        PENDING: "warning",
        IN_ORDER: "info",
        INVOICED: "success",
        PAID: "success",
        CANCELLED: "error"
      };
      return (
        <Chip 
          label={t(row.original.billing_status)}
          size="small"
          color={statusColors[row.original.billing_status] || "default"}
        />
      );
    },
  },
  {
    accessorKey: "service_date",
    header: t("Date"),
    size: 150,
    Cell: ({ row }) => 
      row.original.service_date 
        ? new Date(row.original.service_date).toLocaleDateString()
        : "-"
  },
], [t]);

  const columns = useMemo(
    () => currentTab === 0 ? potentialActivitiesColumns : billedActivitiesColumns,
    [currentTab, potentialActivitiesColumns, billedActivitiesColumns]
  );

  // ============================================================
  // 8. EFFECTS
  // ============================================================

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedActivityIds(selectedIdsArray);
    } else {
      setSelectedActivityIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
  // Limpiar filtros al cambiar de tab
  setActiveFilters([]);
  setFilteredActivitiesList([]); // Limpiar la lista filtrada
  if (currentTab === 0) {
    fetchPotentialActivities();
  } else {
    fetchBilledActivities();
  }
}, [currentTab]);

  // ============================================================
  // 9. UTILIDADES
  // ============================================================

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  

  // ============================================================
  // 10. RENDERIZADO
  // ============================================================

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CLINICAL_MANAGEMENT")
  ) {
    return (
  <div id="content_wrapper">
    <section className="crm-wrapper bg-white pb-5">
      <TabsHeader
        commonHeaderObject={commonHeaderLinkLists(t)}
        activeOption={t("Billable Activities")}
      />

      <div className="container-fluid px-lg-5">
               

        <BillableActivityListHeader 
  reloadList={reloadList}
  selectedItemIds={selectedActivityIds}
  jsonFilterQuery={activeFilters}
  onAddNew={() => setShowAddModal(true)}
  onDelete={() => setShowDeleteModal(true)}
  onOpenPivot={handleOpenPivot}
  onExportCSV={handleExportToCSV}  // ✅ AGREGAR
  onExportPDF={handleExportToPDF}  // ✅ AGREGAR
  currentTab={currentTab}
  filteredActivitiesList={filteredActivitiesList}
  selectedActivityIds={selectedActivityIds}
/>

        {/* Active Filters Display */}
{(activeFilters.length > 0 || true) && ( // Mostrar siempre para incluir el tab
  <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
    <span className="fw-semibold text-muted small">{t("Active Filters")}:</span>
    
    {/* Filtro del Tab actual */}
    <div
      className="d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
      style={{
        backgroundColor: "#e3f2fd",
        border: "1px solid #2196f3",
        borderRadius: "20px",
        fontSize: "14px"
      }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: "16px", color: "#2196f3" }}>
        {currentTab === 0 ? "schedule" : "receipt_long"}
      </span>
      <span className="fw-semibold" style={{ color: "#2196f3" }}>
        {currentTab === 0 ? t("Potential Activities") : t("Billed Activities")}
      </span>
    </div>

    {/* Resto de filtros */}
    {activeFilters.map((filter) => (
      <div
        key={filter.key}
        className="d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
        style={{
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "20px",
          fontSize: "14px"
        }}
      >
        <span>{filter.label}</span>
        <button
          type="button"
          className="btn p-0 d-flex align-items-center justify-content-center"
          style={{
            width: "18px",
            height: "18px",
            backgroundColor: "#f0f0f0",
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            transition: "all 0.2s"
          }}
          onClick={() => handleRemoveFilter(filter.key)}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#ff6347";
            e.currentTarget.querySelector('span').style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f0f0f0";
            e.currentTarget.querySelector('span').style.color = "#666";
          }}
          aria-label="Close"
        >
          <span 
            className="material-symbols-outlined" 
            style={{ fontSize: "14px", color: "#666" }}
          >
            close
          </span>
        </button>
      </div>
    ))}
    
    {activeFilters.length > 0 && (
      <button
        type="button"
        className="btn btn-sm text-danger text-decoration-none ms-auto d-flex align-items-center gap-1"
        onClick={handleClearAllFilters}
        style={{
          border: "1px solid #ff6347",
          borderRadius: "20px",
          padding: "6px 16px",
          backgroundColor: "transparent",
          transition: "all 0.2s"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#ff6347";
          e.currentTarget.style.color = "#fff";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.color = "#dc3545";
        }}
      >
        <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
          filter_alt_off
        </span>
        <span>{t("Clear All")}</span>
      </button>
    )}
  </div>
)}
{/* Modal para crear actividades facturables */}
{currentTab === 0 && (
  <AddBillingActivities
    open={showAddModal}
    onClose={() => setShowAddModal(false)}
    selectedActivities={getSelectedActivities()}
    onSuccess={handleCreateSuccess}
  />
)}
        {/* table */}
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
              <div className="table-wrapper">
            <MaterialReactTable
  columns={columns}
  data={filteredActivitiesList}
  enableGrouping
  enableRowSelection
  getRowId={(row) => currentTab === 0 ? row.source_id : row._id}
  onRowSelectionChange={setRowSelection}
  state={{ rowSelection }}
  muiTableBodyRowProps={({ row }) => ({
    onClick: () => handleViewDetail(row.original),
    sx: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  })}
  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* Componente de Filtro Offcanvas */}
      <BillableActivityFilter
  onApplyFilters={handleApplyFilters}
  onClearFilters={handleClearAllFilters}
  currentTab={currentTab}
  activeFilters={activeFilters}
  onTabChange={(event, newValue) => setCurrentTab(newValue)} // Cambiar esta línea
/>
{/* Drawer de detalle */}
<BillableActivityDetail
  open={showDetailDrawer}
  onClose={() => {
    setShowDetailDrawer(false);
    setSelectedActivityForDetail(null);
  }}
  activity={selectedActivityForDetail}  // ✅ Pasar actividad completa
  currentTab={currentTab}
/>

          {/* Alertas */}
          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
          {/* Modal de confirmación de eliminación con selector de modo */}
{showDeleteModal && (
  <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-dialog-centered modal-lg">
      <div className="modal-content">
        {/* Header */}
        <div className={`modal-header ${deleteMode === 'hard' ? 'bg-danger' : 'bg-warning'} text-white`}>
          <h5 className="modal-title d-flex align-items-center gap-2">
            <span className="material-symbols-outlined">
              {deleteMode === 'hard' ? 'delete_forever' : 'delete'}
            </span>
            {t("Confirm Deletion")}
          </h5>
          <button 
            type="button" 
            className="btn-close btn-close-white" 
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteMode('soft'); // Reset
            }}
            disabled={isDeleting}
          />
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Selector de modo de eliminación */}
          <div className="mb-4">
            <label className="form-label fw-semibold mb-3">
              <span className="material-symbols-outlined align-middle me-2">settings</span>
              {t("Deletion Mode")}:
            </label>
            
            <div className="row g-3">
              {/* Soft Delete Option */}
              <div className="col-md-6">
                <div 
                  className={`card h-100 cursor-pointer ${deleteMode === 'soft' ? 'border-warning border-2 shadow' : 'border'}`}
                  onClick={() => !isDeleting && setDeleteMode('soft')}
                  style={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }}
                >
                  <div className="card-body">
                    <div className="form-check">
                      <input 
                        className="form-check-input" 
                        type="radio" 
                        name="deleteMode"
                        id="softDelete"
                        checked={deleteMode === 'soft'}
                        onChange={() => setDeleteMode('soft')}
                        disabled={isDeleting}
                      />
                      <label className="form-check-label w-100" htmlFor="softDelete">
                        <div className="d-flex align-items-start gap-2">
                          <span className="material-symbols-outlined text-warning" style={{ fontSize: '32px' }}>
                            archive
                          </span>
                          <div className="flex-grow-1">
                            <h6 className="mb-1">{t("Soft Delete")}</h6>
                            <small className="text-muted">
                              {t("Mark as deleted but keep in database. Can be restored later.")}
                            </small>
                            <div className="mt-2">
                              <span className="badge bg-warning text-dark">
                                {t("Reversible")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hard Delete Option */}
              <div className="col-md-6">
                <div 
                  className={`card h-100 cursor-pointer ${deleteMode === 'hard' ? 'border-danger border-2 shadow' : 'border'}`}
                  onClick={() => !isDeleting && setDeleteMode('hard')}
                  style={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }}
                >
                  <div className="card-body">
                    <div className="form-check">
                      <input 
                        className="form-check-input" 
                        type="radio" 
                        name="deleteMode"
                        id="hardDelete"
                        checked={deleteMode === 'hard'}
                        onChange={() => setDeleteMode('hard')}
                        disabled={isDeleting}
                      />
                      <label className="form-check-label w-100" htmlFor="hardDelete">
                        <div className="d-flex align-items-start gap-2">
                          <span className="material-symbols-outlined text-danger" style={{ fontSize: '32px' }}>
                            delete_forever
                          </span>
                          <div className="flex-grow-1">
                            <h6 className="mb-1">{t("Hard Delete")}</h6>
                            <small className="text-muted">
                              {t("Permanently remove from database. Will reappear in potential activities.")}
                            </small>
                            <div className="mt-2">
                              <span className="badge bg-danger">
                                {t("Irreversible")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Alert según modo */}
          <div className={`alert ${deleteMode === 'hard' ? 'alert-danger' : 'alert-warning'} d-flex align-items-start gap-2`}>
            <span className="material-symbols-outlined">
              {deleteMode === 'hard' ? 'dangerous' : 'info'}
            </span>
            <div>
              <strong>{deleteMode === 'hard' ? t("DANGER") : t("Warning")}:</strong>
              <p className="mb-0 mt-1">
                {deleteMode === 'hard' 
                  ? t("This will PERMANENTLY delete the selected activities from the database. All related Sales Orders and Lines will also be deleted. This action CANNOT be undone.")
                  : t("This will mark the activities as deleted but keep them in the database. They can be restored if needed.")
                }
              </p>
            </div>
          </div>
          
          {/* Lista de actividades a eliminar */}
          <p className="mb-2 fw-semibold">
            {t("You are about to delete")} <span className="badge bg-primary fs-6">{selectedActivityIds.length}</span> {t("activities")}:
          </p>
          
          <ul className="list-group mb-3" style={{ maxHeight: '250px', overflowY: 'auto' }}>
            {getSelectedActivities().slice(0, 15).map((activity) => (
              <li key={activity._id || activity.source_id} className="list-group-item py-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span className="badge bg-secondary">{activity.activity_type}</span>
                      <span className="fw-semibold">{activity.patient_name}</span>
                    </div>
                    <small className="text-muted d-block">{activity.description}</small>
                    {activity.service_date && (
                      <small className="text-muted">
                        📅 {new Date(activity.service_date).toLocaleDateString()}
                      </small>
                    )}
                  </div>
                  {activity.product_price && (
                    <span className="badge bg-success">
                      €{Number(activity.product_price).toFixed(2)}
                    </span>
                  )}
                </div>
              </li>
            ))}
            {selectedActivityIds.length > 15 && (
              <li className="list-group-item text-center text-muted py-3">
                <span className="material-symbols-outlined align-middle me-2">more_horiz</span>
                {t("And")} <strong>{selectedActivityIds.length - 15}</strong> {t("more activities...")}
              </li>
            )}
          </ul>
          
          {/* Confirmación final */}
          <div className={`p-3 rounded ${deleteMode === 'hard' ? 'bg-danger bg-opacity-10' : 'bg-warning bg-opacity-10'}`}>
            <p className={`${deleteMode === 'hard' ? 'text-danger' : 'text-warning'} fw-semibold mb-0`}>
              <span className="material-symbols-outlined align-middle me-2">
                {deleteMode === 'hard' ? 'warning' : 'help'}
              </span>
              {deleteMode === 'hard'
                ? t("Are you absolutely sure you want to PERMANENTLY delete these activities?")
                : t("Are you sure you want to soft delete these activities?")
              }
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-secondary d-flex align-items-center gap-2" 
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteMode('soft'); // Reset
            }}
            disabled={isDeleting}
          >
            <span className="material-symbols-outlined">close</span>
            {t("Cancel")}
          </button>
          <button 
            type="button" 
            className={`btn ${deleteMode === 'hard' ? 'btn-danger' : 'btn-warning'} d-flex align-items-center gap-2`}
            onClick={handleBulkDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" />
                {t("Deleting...")}
              </>
            ) : (
              <>
                <span className="material-symbols-outlined">
                  {deleteMode === 'hard' ? 'delete_forever' : 'delete'}
                </span>
                {deleteMode === 'hard' ? t("Permanently Delete") : t("Soft Delete")} ({selectedActivityIds.length})
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

        </section>
      </div>
       
    );
   
  } else {
    return <AccessDeniedView />;
  }
};

export default BillableActivitiesListBody;